import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EulaPopupComponent } from './eulaPopup.component';
import { UserMenuModule } from '../userMenuModule/user-menu.module';



@NgModule({
	imports: [
		CommonModule,
		UserMenuModule
	],
	declarations: [
		EulaPopupComponent
	],
	exports: [
		EulaPopupComponent
	]
})
export class EulaPopupModule {
}
